<script>
    import { createEventDispatcher, onMount } from 'svelte';
    import {cssVariables} from '../utils/CSSVariables';
    import { get } from "svelte/store";
    import {currentTable} from "../stores/tablesStore";
    import Layout from '../controllers/Layout';
    
    export let amount = 0;
    export let seat = 0;
    export let pot = 0;
    
    let xOffset;
    let yOffset;

    export function setAmount(value)
    {
        amount = value;
    }

    export function getAmount(value)
    {
        return amount;
    }

    onMount(async () => 
    {
        let tableType = get(currentTable).table_type;
        
        if (seat > 0)
        {
            xOffset = Layout[tableType]["seat" + seat].betOffsets[0];
            yOffset = Layout[tableType]["seat" + seat].betOffsets[1];
        }
        else
        {
            if (Layout[tableType]["pots"][[pot]])
            {
                xOffset = Layout[tableType]["pots"][pot][0];
                yOffset = Layout[tableType]["pots"][pot][1];
            }
        }
	});
    

</script>

{#if amount > 0}
<div class="vbox pokerChips center" use:cssVariables={{xOffset, yOffset}}>
        <img class="chips" src={"/assets/chips.png"}>
        <span class="betAmount">{amount}</span>
</div>
{/if}


<style>
    .pokerChips {
        position: absolute; 
        width: 50px;
        height: 18px;
        margin: 0px;
        padding: 0px;
        left:  calc(var(--xOffset) * 1px);
        top:  calc(var(--yOffset) * 1px);
        text-align: left; 
    }

    .betAmount {
        font-weight: bold;
        font-size: small;
        color: white;
        padding: 2px;
    }

    .chips {
        width: 25px;
        height: 18px;
    }

</style>